import React from 'react';

// The score, rendered the way the product renders a score everywhere it matters:
// a large serif numeral filled with a vertical gold gradient.
//
// WHY THIS FILE EXISTS
// The gradient was written out by hand in VaultFocusView (the scan detail) and
// again in Create (the reveal delta), and Home was about to become the third
// copy. Three literals of the same four-line style is exactly the repetition
// CLAUDE.md says to flag, and a score that is a slightly different gold on one
// surface reads as a different metric.
//
// `background-clip: text` needs a transparent foreground and BOTH the prefixed
// and unprefixed clip properties — Safari still only honours the -webkit- one.
export const GOLD_NUMERAL_STYLE = Object.freeze({
  backgroundImage: 'linear-gradient(180deg, #EDD3A2, #9A7B40)',
  WebkitBackgroundClip: 'text',
  backgroundClip: 'text',
  color: 'transparent',
});

// Props:
//   value   already formatted for display (the /10 string, not the raw 1-100)
//   size    font size in px
//   label   optional eyebrow above the numeral
const ScoreNumeral = ({ value, size = 64, label = null, className = '', ...rest }) => (
  <div className={className} {...rest}>
    {label && (
      <p
        className="font-display uppercase tracking-[0.22em] text-bone-dim m-0"
        style={{ fontSize: 11 }}
      >
        {label}
      </p>
    )}
    <p
      data-testid="score-numeral"
      className="font-display font-medium m-0 mt-1 tabular-nums"
      style={{ fontSize: size, lineHeight: 1, ...GOLD_NUMERAL_STYLE }}
    >
      {value}
    </p>
  </div>
);

export default ScoreNumeral;
